import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Header from '../layout/Header';
import Default from './Default';

export default class Legal extends Default {
  id;
  isWrapAutoRemove = true;

//==================================================================================================================
//          CONSTRUCTOR
//==================================================================================================================

  constructor() {
    super();
    document.body.classList.add("body-legal");
  }

  afterHide() {
    document.body.classList.remove("body-legal");
    Header.overlayAlpha = .35;
    Header.hideOverlay();
    super.afterHide();
  }

  beforeShow() {
    Header.openHeader();
    Header.overlayAlpha = 1;
    Header.showOverlay(true, false);
    super.beforeShow();
  }
}

ControllerPage._addPage("legal", Legal)
